import { AbstractControl, FormArray, FormGroup, ValidationErrors } from '@angular/forms';

export function addError(control: AbstractControl, errorName: string): void {
  const errors = control.errors || {};
  errors[errorName] = true;
  control.setErrors(errors);
}

export function removeError(control: AbstractControl, errorName: string): void {
  const errors = control.errors || {};
  delete errors[errorName];
  const hasMoreError = Object.keys(errors).length > 0;
  control.setErrors(hasMoreError ? errors : null);
}

export function getFormValidationErrors(form: FormGroup): any {
  const result = [];
  Object.keys(form.controls).forEach((key) => {
    const formProperty = form.get(key);
    if (formProperty instanceof FormGroup) {
      result.push(...getFormValidationErrors(formProperty));
    }
    const controlErrors: ValidationErrors = formProperty.errors;
    if (controlErrors) {
      Object.keys(controlErrors).forEach((keyError) => {
        result.push({
          'control': key,
          'error': keyError,
          'value': controlErrors[keyError]
        });
      });
    }
  });

  return result;
}


export function logFromErrors(parentKeyName: String | number, parent: AbstractControl): void {
  if (parent instanceof FormGroup) {
    Object.keys(parent.controls).forEach((key) => {
      const control = parent.controls[key];
      logFromErrors(key, control);
    });
    return;
  }

  if (parent instanceof FormArray) {
    parent.controls.forEach((control, index) => {
      logFromErrors(index, control);
    });
    return;
  }
}
